import React, { useState, useEffect } from 'react'
import Select from "react-dropdown-select";
import PhoneInput from 'react-phone-input-2';
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { saveStepSuccessForLoggedOut, storeSavedData, handleProgramSelection as handleProgramSelectionAction } from '../../../store/actions/application'
import { saveFormStep } from '../../../api/application'

function BeginningScreen (props){
  const dispatch = useDispatch();
  const [showFirstScreen, setShowFirstScreen] = useState(true);
  const [showSecondScreen, setShowSecondScreen] = useState(false);
  const [user, setUser] = useState(props.user);
  const [showEmail, setShowEmail] = useState(false);
  const [selectedProgram, setSelectedProgram] = useState(null)
  const [loading, setLoading] = useState(false);

  const { savedSteps, selectedProgramId, selectedProgramLabel, userAuth } = useSelector((state) => ({
    savedSteps: state.applicationReducer.savedSteps,
    selectedProgramId: state.applicationReducer.selectedProgramId,
    selectedProgramLabel: state.applicationReducer.selectedProgramLabel,
    userAuth: state.userAuth
  }), shallowEqual);

  const [state, setState] = useState({
    formData: {
      percent_completed: 5,
      first_name: userAuth?.name?.split(' ')[0] ?? '',
      last_name: userAuth?.name?.split(' ')[1] ?? '',
      userEmail: userAuth.email ?? '',
      confirmUserEmail: '',
      primary_phone_no: '',
      programId: ''
    },
    first_nameValid: '',
    last_nameValid: '',
    isFormDataValid: '',
    hideMobile : false,
    userEmailValid: '',
    confirmUserEmailValid: '',
    primary_phone_noValid: '',
    programIdValid: ''
  });

  useEffect(()=>{
    window.scrollTo(0, 0)
    if (!!savedSteps.loggedOutUserInfo) {
      populateForm();
    }
    if(!!state.formData.first_name) _validate('first_name');
    if(!!state.formData.last_name) _validate('last_name');
    if(!!state.formData.userEmail) _validate('userEmail');
  },[])

  useEffect(()=>{
    populateForm();
  },[savedSteps.loggedOutUserInfo])

  useEffect(()=>{
    validateForm();
  },[state])

  useEffect(()=>{
    if(state.formData.program_id && !selectedProgram && props.programs?.length){
      handleSetSelectedProgram(props.programs.find(p => p.id == state.formData.programId));
    }
  },[state.formData.programId])

  function populateForm(){
    const loggedOutUserInfoData = savedSteps.loggedOutUserInfo;
    if (!!savedSteps.loggedOutUserInfo && Object.keys(loggedOutUserInfoData).length > 0) {
      updateForm('first_name', loggedOutUserInfoData.first_name);
      updateForm('last_name', loggedOutUserInfoData.last_name);
      updateForm('userEmail', loggedOutUserInfoData.email);
      updateForm('confirmUserEmail', loggedOutUserInfoData.confirm_email);
      updateForm('primary_phone_no', loggedOutUserInfoData.phone_number);
      // updateForm('programId', loggedOutUserInfoData.program_id);
      if(props.programs.some(p => p.id == loggedOutUserInfoData.program_id)){
        handleSetSelectedProgram(props.programs.find(p => p.id == loggedOutUserInfoData.program_id));
      }
    }
  }

  const updateForm = (field, value) => {
    let temp = state.formData
    temp[field] = value
    setState(prevState => ({ ...prevState, formData: temp}));
    _validate(field);
  }

  const _validate = (field) => {
    let regex, valid;
    let value = state.formData[field];
    switch(field){
      case 'programId':
        regex = /^[0-9]+$/;
        valid = regex.test(value)
        break;
      case 'primary_phone_no':
        regex = /^.{10,}/;
        valid = regex.test(value)
        break;
      case 'first_name' : case 'last_name':
        regex = /^.{2,}/;
        valid = regex.test(value)
        break;
      case 'userEmail':
        regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        valid = regex.test(value)
        break;
      case 'confirmUserEmail':
        valid = state.formData.userEmail === value
      break;
    }
    setState(prevState => ({ ...prevState, [field+"Valid"]: valid }));
  }

  const validateForm = () => {
    let formData = state
    let form = !!formData.first_nameValid &&
    !!formData.last_nameValid &&
    !!formData.userEmailValid &&
    !!formData.confirmUserEmailValid &&
    !!formData.programIdValid &&
    !!formData.primary_phone_noValid;
    if (state.isFormDataValid != form) {
      setState(prevState => ({...prevState, isFormDataValid: form}));
    }
  }

  const handleInfoSubmission = () => {
    setLoading(true)
    const formData = {};
    formData.completed_step = "loggedOutUserInfo";
    formData.email = state.formData.userEmail;
    formData.program_id = state.formData.programId;
    formData.first_name = state.formData.first_name;
    formData.last_name = state.formData.last_name;
    formData.confirm_email = state.formData.confirmUserEmail;
    formData.phone_number = state.formData.primary_phone_no;
    formData.form_step = "loggedOutUserInfo";
    formData.next_step = "applicantInfo";
    formData.percent_completed = 0;
    if (!!savedSteps?.id) formData.hashed_id = savedSteps?.id;
    saveFormStep(formData).then(res => {
      if(res) {
        res.email = state.formData.userEmail;
        dispatch(saveStepSuccessForLoggedOut(res));
        dispatch(storeSavedData({data: formData, step: formData.form_step}));
      }
      if(!selectedProgram && selectedProgramId){
        handleSetSelectedProgram(props.programs.find(p => p.id == selectedProgramId));
      }
      setShowFirstScreen(false)
      setShowSecondScreen(true);
      window.scrollTo(0, 0)
      setLoading(false)
    });
  }

  const handleSetSelectedProgram = program => {
    setSelectedProgram(program);
    dispatch(
      handleProgramSelectionAction({
        programId: program?.id,
        programLabel: program?.label,
      })
    );
    updateForm("programId", program?.id)
  }

  const handleHideMobile = () => {
    setState({
      ...state, hideMobile: true
    })
  }

  const handleBegin = () => {
    props.startApplication(state.formData.userEmail)
  }

  return(
    <>
      	<div className="bayan-steps-wrapper ">
          <div className="begin-screen card ">
          {showFirstScreen &&
          <>
          <h2 className="">
            Apply to Bayan
          </h2>
          {/* <div className="sub-heading app-info">
          </div> */}
          <p>Please select your program of interest and fill in the below information to get started on your Bayan application.</p>

          <div className="input-group">
            <div className="field-label">Select a Program</div>
            <Select
							options={props.programs}
							multi={false}
							placeholder="Select a Program"
							dropdownGap={3}
							className="program-dropdown select-field-program"
							dropdownHeight="300px"
							style={{background: '#F2F2F2 0% 0% no-repeat padding-box'}}
							onChange={(values) => handleSetSelectedProgram(values[0])}
              values={selectedProgramId && props.programs && props.programs.length > 0 ? [props.programs.find(opt => opt.id === selectedProgramId)]: []}
              />

            {(state.programIdValid === false) && <div className="field-error">Must select program</div>}
          </div>


          <div className="input-group">
            <div className="field-label">First Name</div>
            <input type='text' className={(state.first_nameValid === false) ? 'error' : ''} value={state.formData.first_name} placeholder='Enter Name' onChange={(e) => {updateForm('first_name', e.target.value)}} />
            {(state.first_nameValid === false) && <div className="field-error">Must enter first name.</div>}
          </div>
          <div className="input-group">
            <div className="field-label">Last Name</div>
            <input type='text' className={state.last_nameValid  === false ? 'error' : ''} value={state.formData.last_name} placeholder='Enter Last Name' onChange={(e)=>{updateForm('last_name', e.target.value)}}/>
            {state.last_nameValid  === false && <div className="field-error">Must enter last name.</div>}
          </div>

          <div className="input-group">
            <div className="field-label">Email</div>
                <input id="_email" name="email" type="email" className="is-input email-field " readOnly={userAuth.token ? true : false}
								placeholder="Email" value={state.formData.userEmail} onBlur={(e) => updateForm('userEmail', e.target.value)} onChange={(e) => {updateForm('userEmail', e.target.value)}} />
							{state.userEmailValid === false && <small className='err-msg'>*Must enter a valid Email.</small>}
          </div>

          <div className="input-group">
            <div className="field-label">Confirm Email</div>
            <input id="_email" name="email" type="email" className="is-input email-field "
								placeholder="Email" value={state.formData.confirmUserEmail} onBlur={(e) => updateForm('confirmUserEmail', e.target.value)} onChange={(e) => updateForm('confirmUserEmail', e.target.value)} />
            {state.confirmUserEmailValid === false && <small className='err-msg'>*Emails must match.</small>}
          </div>

          <div className="input-group">
            <div className="field-label">Phone Number</div>
            <PhoneInput
              country={'us'}
              value={state.formData.primary_phone_no}
              inputClass={state.primary_phone_noValid === false ? 'error' : ''}
              onChange={(num)=> updateForm('primary_phone_no', num)}
            />
            {(state.primary_phone_noValid === false) && <small className="err-msg">Must enter Phone Number.</small>}
          </div>
          <button className={`begin-btn ${!state.isFormDataValid ? 'btn-disabled': ''}`} onClick={() => handleInfoSubmission()}>Begin{loading && <img src={`/icons/loading.svg`} style={{ height: '25px', marginLeft: '10px' }} />}</button>
          </>
          }

          {showSecondScreen &&
            <>
            <div className="main-heading bayan-main-heading">
              <img src="/icons/empty-network.png" />
              Bayan Islamic Graduate School.
            </div>
            <div className="body-content">
              <h6>{selectedProgram?.label || 'Program Unknown'}</h6>
              <div
              dangerouslySetInnerHTML={{ __html: selectedProgram.description }}
              ></div>
              {/* {!state.hideMobile && <div className="addnumber">
                <input placeholder="(555) 555-5555" />
                <button className="addbtn" onClick={handleHideMobile()}>Add Number</button>
              </div>}
                <div className="addnumber">
                  {showEmail &&
                  <input type='email' placeholder="Enter email" value={state.userEmail} onChange={(e) => updateField('userEmail', e.target.value)} />
                  }
                  {showEmail && !validateForm() && <small className='err-msg'>*Must enter a valid Email.</small>}

                </div> */}
              {/* <p>* indicates a required field. All fields will autosave changes.</p> */}
              {/* <p>The Master of Arts (Religious Studies) in Islamic Studies is a two-year graduate program that focuses on the study of religious traditions, theology and ethics. Culminating with a Master’s Thesis, this program allows you to concentrate your studies in an area of interest. This is an appropriate degree if you are preparing for further study at the doctoral level; seeking advanced theological study as a foundation for service; or simply wish to study theology and religion without the aim of entering professional ministry.</p>
              <p><strong>Application Deadlines:</strong></p>
              <p>November 30th - Spring Admission <br />February 15th - Priority Fall Admission and Merit Scholarships<br />June 1st - Recommended Deadline for Fall Admission</p>
              <p><strong>Master of Arts in Religious Studies Handbook:</strong> https://www.ctschicago.edu/wp-content/uploads/2017/08/MA-Handbook-2017-18.pdf </p><p><strong>Anti-Harassment/Anti-Discrimination General Policy Statement and Notice of Non-Discrimination and Non-Harassment</strong> </p>
              <p>Chicago Theological Seminary is committed to fostering the full humanity of all its members. All forms of discrimination and harassment impugn the full humanity of any human being and for this reason are not tolerated in this Seminary. Chicago Theological Seminary does not discriminate, or tolerate discrimination or harassment, against any member of its community on the basis of race, color, national origin, ancestry, sex/gender, age, religion, disability, pregnancy, veteran status, marital status, sexual orientation, or any other status protected by applicable federal, state, or local law in matters of employment or admissions or in any aspect of the educational programs or activities it offers.</p>
              <p>To read more about our commitments as a seminary click here: https://www.ctschicago.edu/commitments</p> */}
            </div>
            <button className={`begin-btn`} onClick={() => handleBegin()}>Begin</button>
            </>
          }
          </div>
        </div>
    </>
  );
}

export default BeginningScreen;
